import React from "react";
import VersionsContainer from "./VersionsContainer";
import InvalidateCacheContainer from "./InvalidateCacheContainer";
import InsuranceFlowChecksContainer from "./flowChecks/InsuranceFlowChecksContainer";

const SettingsContainer = () => {
  return (
    <>
      <VersionsContainer />
      <InvalidateCacheContainer />
      <InsuranceFlowChecksContainer />
    </>
  );
};

export default SettingsContainer;
